module.exports = __webpack_public_path__ + "static/media/10.f2652b5b.jpg";